import { ScrollbarWidth } from '@/js/App/ScrollbarWidth'

new ScrollbarWidth()
